/** Vertical floor pills, highest floor on top. */
export default function FloorSelector({
  floors,
  activeFloorId,
  onSelect,
  routeFloorIds,
  compact = false,
  docked = false,
}) {
  if (!floors || floors.length < 2) return null;
  const ordered = [...floors].sort((a, b) => b.level - a.level);
  return (
    // On a phone the vertical middle of the screen is the map; the pills sit
    // just under the language picker so nothing lands on the bottom sheet.
    <div
      className={
        "absolute z-10 flex flex-col gap-1.5 " +
        // Top-docked menu (item 0373): the pills come down out of its way.
        // Phone: bottom-left, above the language picker. Portrait totem:
        // bottom-right, above the compass (bottom-48 + 40px). ViewerPage
        // stops the menu column above either stack (dockReserve).
        (docked
          ? compact
            ? "bottom-16 left-3"
            : "bottom-64 right-3"
          : compact
            ? "right-3 top-20"
            : "right-3 top-1/2 -translate-y-1/2")
      }
    >
      {ordered.map((floor) => {
        const active = floor.id === activeFloorId;
        const onRoute = routeFloorIds?.includes(floor.id);
        return (
          <button
            key={floor.id}
            onClick={() => onSelect(floor.id)}
            className={
              "h-11 w-11 rounded-lg text-sm font-bold shadow-md transition-colors " +
              (active
                ? "bg-slate-800 text-white"
                : "bg-white text-slate-700 active:bg-slate-100") +
              (onRoute && !active ? " ring-2 ring-[#e63946]" : "")
            }
          >
            {floor.short_label || floor.level}
          </button>
        );
      })}
    </div>
  );
}
